import { useTranslation } from 'react-i18next'
import type { IconName } from '../../../components/Icon.tsx'
import type { PanelControls } from '../../../components/Layouts.tsx'
import { ids } from '../../../ids.ts'

export const reportViews = ['map', 'table'] as const
export type ReportView = (typeof reportViews)[number]

const viewIcons = { map: 'Map', table: 'Table' } satisfies Record<ReportView, IconName>

export const useReportViewControls = ({
	views,
	value,
	onChange,
}: {
	views: readonly ReportView[]
	value: ReportView
	onChange: (view: ReportView) => void
}): PanelControls<ReportView> => {
	const { t } = useTranslation()

	return {
		options: views.map((view) => ({ value: view, icon: viewIcons[view], label: t(($) => $.reports.display.views[view]) })),
		value,
		onChange,
		getDataTa: ids.reports.displayResults.view,
		getRailDataTa: ids.reports.displayResults.railView,
	}
}
